import { Box, Pagination, PaginationItem } from "@mui/material";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import styled from "styled-components";

const PaginationBox = ({
  totalPages,
  page,
  handleChangePage,
  isShortContent,
  selectedColor = "green",
}) => {
  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: selectedColor,
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  return (
    <div
      style={{
        marginBottom: isShortContent ? "5rem" : "0rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          position: isShortContent ? "fixed" : "relative",
          bottom: 0,
          left: isShortContent ? "calc(23% + 0.4rem)" : "0",
          right: 0,
          marginTop: isShortContent ? "auto" : "16px",
          zIndex: 999,
          width: isShortContent ? "calc(100% - 26%)" : "100%",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          padding: "4px 16px",
          boxShadow: "0px 1px 0px 0px #EDEFF1 inset",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#ffffff",
            width: "100%",
            height: "40px",
          }}
        >
          <Box
            onClick={(event) => page > 1 && handleChangePage(event, page - 1)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flex: 1,
              color: page === 1 ? "#9e9e9e" : selectedColor,
              cursor: page === 1 ? "not-allowed" : "pointer",
              userSelect: "none",
              height: "40px",
              lineHeight: 1,
              fontSize: "16px",
            }}
          >
            <ArrowBackIcon sx={{ mr: 1, color: "inherit" }} />
            <Box
              component="span"
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
                fontWeight: "400",
                color: page === 1 ? "#9e9e9e" : "#222222",
                cursor: page === 1 ? "not-allowed" : "pointer",
              }}
            >
              Previous
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "40px",
            }}
          >
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePage}
              hidePrevButton
              hideNextButton
              renderItem={(item) => (
                <StyledPaginationItem
                  {...item}
                  sx={{
                    "& .MuiPaginationItem-root": {
                      mx: 1,
                      minWidth: "32px",
                      height: "32px",
                      lineHeight: 1,
                    },
                    "& .MuiPagination-ul": {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  }}
                />
              )}
            />
          </Box>

          <Box
            onClick={(event) =>
              page < totalPages && handleChangePage(event, page + 1)
            }
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flex: 1,
              color: page === totalPages ? "#9e9e9e" : selectedColor,
              cursor: page === totalPages ? "not-allowed" : "pointer",
              userSelect: "none",
              height: "40px",
              lineHeight: 1,
              fontSize: "16px",
            }}
          >
            <Box
              component="span"
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
                fontWeight: "400",
                color: page === totalPages ? "#9e9e9e" : "#222222",
                cursor: page === totalPages ? "not-allowed" : "pointer",
              }}
            >
              Next
            </Box>
            <ArrowForwardIcon sx={{ ml: 1, color: "inherit" }} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default PaginationBox;
